<template>
  <v-dialog
    :value="true"
    max-width="600"
    persistent
    @click:outside="close"
  >
    <v-card class="all-set-modal">
      <v-card-title class="modal-title">
        All set — your community is ready
      </v-card-title>

      <v-card-text class="modal-content">
        <p class="description-text">
          Your community has been created successfully. You can now start inviting members
          and exploring all the features available to you.
        </p>

        <p class="description-text">
          You can always access the help center if you need guidance on how to manage your community.
        </p>
      </v-card-text>

      <v-card-actions class="modal-actions">
        <v-spacer />

        <v-btn
          rounded
          class="done-btn"
          @click="close"
        >
          Done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AllSetModal',
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.all-set-modal {
  padding: 16px;
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #14161B;
  padding: 16px 16px 8px;
  word-break: break-word;
}

.modal-content {
  padding: 16px;
}

.description-text {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #6B6B6B;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.modal-actions {
  padding: 8px 16px 16px;
}

.done-btn {
  background-color: #28EA96 !important;
  color: #005931 !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  padding: 0 24px !important;

  &:hover {
    background-color: #1FD67F !important;
  }
}
</style>
